import {
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import {
  findLatestPreOrderAvailableFromDate,
  getNextStartDate,
} from "@sellar-io/common";
import { getNextDirectDeliveryDate } from "../../pages/order/helpers/DeliveryDateHelpers/getNextDeliveryDate";

export const useDirectDeliveryEstimate = ({
  supplier,
  directDeliveryArea,
  preorderAvailableFromDates,
}: {
  supplier: SupplierGetResponseType;
  directDeliveryArea: SupplierStorefrontV2GetResponseType["DeliveryArea"];

  preorderAvailableFromDates: Array<{ availableFrom: Date | null }>;
}) => {
  const latestAvailablePreOrderFromDate = findLatestPreOrderAvailableFromDate(
    preorderAvailableFromDates,
  );
  const outOfOfficeReturnDate = supplier.SupplierOutOfOffice?.outOfOffice
    ? supplier.SupplierOutOfOffice.returnDate
    : null;

  const startDateReference = getNextStartDate({
    latestAvailablePreOrderFromDate,
    outOfOfficeReturnDate,
    courierDeliveryScheduleStartDate: null,
    currentDate: new Date(),
  });

  if (!directDeliveryArea) {
    return {
      nextDirectDeliveryDate: null,
    };
  }

  const nextDirectDeliveryDate = getNextDirectDeliveryDate({
    deliveryArea: directDeliveryArea,
    startDateReference: startDateReference,
  });

  return {
    nextDirectDeliveryDate,
  };
};
